// extracted by mini-css-extract-plugin
export var currencyInput = "_n8-1";
export var currencySymbol = "_n8-0";